<template>
	<v-dialog v-model="showDialog" max-width="800px" scrollable persistent>
		<v-card v-if="selected">
			<v-card-title v-if="!selected.EntityId"> Add filter </v-card-title>
			<v-card-title v-if="selected.EntityId">
				Edit filters for {{ selected.Entity }} entity
			</v-card-title>
			<v-card-text>
				<v-form
					ref="form"
					:disabled="
						(!canEdit && selected.Entity) ||
						(!canAdd && !selected.Entity)
					"
				>
					<v-select
						v-if="!entityId"
						v-model="selected.EntityId"
						class="mx-1 mb-4"
						item-text="Name"
						item-value="Id"
						label="Entity"
						:items="entities"
						dense
						outlined
						@change="loadFields"
						:rules="entityRule"
					/>
					<div
						v-for="(filter, index) in selected.Filters"
						:key="index"
					>
						<filter-component
							class="d-flex mb-4"
							v-if="filter && !filter.IsDeleted"
							:columns="fields"
							:filter="filter"
							:index="index"
							@onRemoveFilter="removeFilter"
							@filterChanged="filterChanged"
						/>
					</div>
				</v-form>
				<v-btn
					v-if="canEdit"
					color="primary"
					outlined
					@click="addFilter()"
				>
					<v-icon>mdi-plus</v-icon>
					Add filter
				</v-btn>
			</v-card-text>

			<v-card-actions>
				<v-spacer />
				<v-btn text outlined @click="cancel()"> Close </v-btn>
				<v-btn
					v-if="
						(canEdit && selected.GridViewId) ||
						(canAdd && !selected.GridViewId)
					"
					color="primary"
					@click="submit()"
				>
					Submit
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { InventoryFormFiltersGetters } from '../../../../store/getters';
import { InventoryFormFiltersActions } from '../../../../store/actions';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
import FilterComponent from '../../../shared/gridViews/FilterComponent.vue';
import { mapGetters } from 'vuex';
export default {
	name: 'FilterModal',
	mixins: [permissionsMixin],
	components: { FilterComponent },
	props: {
		showDialog: Boolean,
		selected: Object,
	},
	computed: {
		...mapGetters({
			entities: [InventoryFormFiltersGetters.ENTITIES],
			fields: [InventoryFormFiltersGetters.FIELDS],
		}),
		canView() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Filters.View,
			]);
		},
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Filters.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Filters.Edit,
			]);
		},
	},
	data() {
		return {
			entityId: null,
			entityRule: [(v) => !!v || 'Entity is required'],
			fieldRule: [(v) => !!v || 'Field is required'],
			operatorRule: [(v) => !!v || 'Operator is required'],
			valueRule: [(v) => !!v || 'Value is required'],
		};
	},
	mounted() {
		if (this.selected.EntityId) {
			this.entityId = this.selected.EntityId;
			this.loadFields(this.entityId);
		}
	},
	destroyed() {
		this.$store.dispatch(InventoryFormFiltersActions.CLEAR_FIELDS);
	},
	methods: {
		cancel() {
			this.$emit('cancel');
		},
		addFilter() {
			this.selected.Filters.push({
				FieldId: '',
				Operator: null,
				IsDeleted: false,
				Value: '',
			});
		},
		submit() {
			if (this.$refs.form.validate()) {
				if (this.selected.GridViewId) {
					this.$store.dispatch(
						InventoryFormFiltersActions.UPDATE_FILTERS,
						this.selected
					);
				} else {
					this.$store.dispatch(
						InventoryFormFiltersActions.INSERT_FILTERS,
						this.selected
					);
				}
				this.$emit('cancel');
			}
		},
		removeFilter(index) {
			this.selected.Filters[index].IsDeleted = true;
		},
		loadFields(value) {
			this.selected.EntityId = value;
			this.$store.dispatch(
				InventoryFormFiltersActions.LOAD_FIELDS,
				value
			);
		},
		filterChanged(param, index) {
			this.selected.Filters.splice(index, 1, param);
		},
	},
};
</script>
